export default {
  //用户列表
  slide: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/slide/list.vue'));
    }, '/modules/slide/list');
  },
  //首页设置
  totalIndex: resolve => {
    require.ensure([], () => {
      resolve(require('@/views/slide/total-index.vue'));
    }, '/modules/slide/total-index');
  }

}



// WEBPACK FOOTER //
// ./src/router/modules/slide.js